import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Group from './Group';

const CheckboxInput = ({name, label}) => (
  <Group className="group-checkbox">
    <Field component="input" id={`checkbox-${name}`} type="checkbox" name={name} />

    <label htmlFor={`checkbox-${name}`}>{label}</label>
  </Group>
);

CheckboxInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired
};

export default CheckboxInput;



// WEBPACK FOOTER //
// ./components/Form/CheckboxInput.jsx